import axios from "../axios";

const API_PATH = "/administration";

// TODO merge with organization-administration.js

const adminApi = {
  /**
   * Get all organizations accross the platform
   * @param accesToken
   * @returns {Promise<AxiosResponse<any>>}
   */
  getAllOrgs(accesToken) {
    const config = {
      headers: { Authorization: `Bearer ${accesToken}` },
    };
    return axios.get(`${API_PATH}/organization`, config).then(({ data }) => data);
  },

  /**
   * Update modules for an organization
   * @param {string} accessToken - The access token for authorization
   * @param {Object} data - The data to update the organization modules
   * @param {string[]} data.modules - List of modules
   * @param {string} data.tenantId - The tenant ID
   * @returns {Promise<AxiosResponse<any>>}
   */
  updateOrgModules(data) {
    return axios.post(`${API_PATH}/organization/modules`, data).then(({ data }) => data);
  },

  createOrg(data) {
    return axios.post(`${API_PATH}/organization`, data).then(({ data }) => data);
  },
};

export default adminApi;
